module.exports = __webpack_public_path__ + "static/media/Book - It Makes Sense to Believe 2.42219597.docx";